import React, { useEffect, useRef } from 'react';
import { Container, Col, Row, Button } from 'react-bootstrap';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/about.css';
import { useLocation } from "react-router-dom";

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const images = {
    // banner: require('../image/about.jpg'),
    story: require('../image/story.png'),
    mission: require('../image/mission.png'),
};

const About = () => {

    const { pathname } = useLocation();

    const storyRef = useRef([]);
    storyRef.current = [];

    const storylineRef = useRef([]);
    storylineRef.current = [];

    // all imgs and texts animation
    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger);

        storyRef.current.forEach((img, i) => {
            gsap.fromTo(
                img,
                { opacity: 0, scale: 0.9, x: i % 2 === 0 ? -80 : 80 },
                {
                    opacity: 1,
                    scale: 1,
                    x: 0,
                    duration: 1.4,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: img,
                        start: "top 80%",
                        end: "top 40%",
                        scrub: 1.2,
                    },
                }
            );
        });

        storylineRef.current.forEach((text, i) => {
            gsap.fromTo(
                text,
                { opacity: 0, y: 40, x: i % 2 === 0 ? 40 : -40 },
                {
                    opacity: 1,
                    y: 0,
                    x: 0,
                    duration: 1.4,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: text,
                        start: "top 85%",
                        end: "top 50%",
                        scrub: 1.1,
                    },
                }
            );
        });
    }, []);

    useEffect(() => {
        requestAnimationFrame(() => {
            window.scrollTo({ top: 0, left: 0, behavior: "auto" });
        });
    }, [pathname]);

    return (
        <>
            {/* slider */}
            {/* <section id="about" className="hero_slider">
                <div>
                    <img
                        src={images.banner}
                        className="d-block w-100 abimg"
                        alt="img-1"
                        style={{
                            objectFit: 'cover', boxShadow: 'rgba(0, 0, 0, 7) 0px -50px 36px -28px inset',
                            maskImage:
                                "linear-gradient(to bottom, transparent 0%, rgba(0,0,0,1) 10%, rgba(0,0,0,1) 85%, transparent 100%)",
                            WebkitMaskImage:
                                "linear-gradient(to bottom, transparent 0%, rgba(0,0,0,1) 10%, rgba(0,0,0,1) 85%, transparent 100%)",

                        }}
                    />
                    <Container className="carousel-caption-about col-md-6 col-10 col-offset-md-6">
                        <h1>Uniforms With Pride</h1>
                    </Container>
                </div>
                <Container className="carousel-caption-about2 col-md-6 col-10 col-offset-md-6">
                    <h1>Uniforms With Pride</h1>
                </Container>
            </section> */}

            {/* 1 */}
            <section className="story-section py-5">
                <Container fluid>
                    <Row className="align-items-center">
                        {/* Text Column */}
                        <Col
                            ref={(el) => storylineRef.current[1] = el}
                            xs={12}
                            lg={5}
                            className="p-5 text-lg-end text-center d-flex flex-column justify-content-center"
                        >
                            <h2 className="fw-bold mb-3">Our Journey</h2>
                            <p className="text-muted mb-4">
                                From humble beginnings in Surat to becoming a trusted name in
                                corporate and industrial uniforms, our story is built on quality,
                                dedication, and client satisfaction.
                            </p>
                            <div>
                                <Button variant="danger" className="rounded-pill px-4">
                                    Read Our Story
                                </Button>
                            </div>
                        </Col>

                        {/* Image Column */}
                        <Col xs={12} lg={7} className="p-0" ref={(el) => storyRef.current[1] = el}>
                            <img
                                src={images.story}
                                alt="Our story"
                                className="w-100 h-100 object-fit-cover"
                                style={{ objectFit: "cover", minHeight: "300px" }}
                            />
                        </Col>
                    </Row>
                </Container>
            </section>
            <br />

            {/* 2 */}
            <section className="story-section py-5">
                <Container fluid>
                    <Row className="align-items-center flex-lg-row flex-column-reverse" ref={(el) => storyRef.current[2] = el}>
                        <Col xs={12} lg={7} className="p-0">
                            <img
                                src={images.mission}
                                alt="Our Mission"
                                className="w-100 h-100"
                                style={{ objectFit: "cover", minHeight: "300px" }}
                            />
                        </Col>
                        <Col
                            ref={(el) => storylineRef.current[2] = el}
                            xs={12}
                            lg={5}
                            className="p-5 text-lg-start text-center d-flex flex-column justify-content-center"
                        >
                            <h2 className="fw-bold mb-3">Our Mission</h2>
                            <p className="text-muted mb-3">
                                To craft premium, durable, and comfortable uniforms that reflect
                                professionalism and pride for every employee, across industries
                                and organizations.
                            </p>

                            <ul className="list-unstyled mb-4">
                                <li>✅ Quality First</li>
                                <li>✅ Comfort & Fit</li>
                                <li>✅ Reliable Service</li>
                            </ul>

                            <div>
                                <Button variant="danger" className="rounded-pill px-4">
                                    See Our Vision
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <br />

            {/* 3 */}
            <section className="story-section py-5">
                <Container fluid>
                    <Row className="align-items-center flex-column-reverse flex-lg-row">
                        {/* ✅ Text Column */}
                        <Col
                            ref={(el) => storylineRef.current[3] = el}
                            xs={12}
                            lg={5}
                            className="p-5 text-lg-end text-center d-flex flex-column justify-content-center"
                        >
                            <h2 className="fw-bold mb-3">Why Choose Us</h2>
                            <p className="text-muted mb-4">
                                Trusted by Surat’s leading companies, we combine top-quality
                                fabrics, expert tailoring, and timely delivery to make every
                                uniform perfect.
                            </p>
                            <div>
                                <Button variant="danger" className="rounded-pill px-4">
                                    What Makes Us Different
                                </Button>
                            </div>
                        </Col>

                        {/* ✅ Lottie Animation Column */}
                        <Col xs={12} lg={7} className="p-0 d-flex justify-content-center" ref={(el) => storyRef.current[3] = el}>
                            <div
                                style={{
                                    width: "100%",
                                    maxWidth: "600px",
                                    height: "auto",
                                }}
                            >
                                <DotLottieReact
                                    src="https://lottie.host/943535da-34c9-41e0-9d42-decbd16b553d/BZpd0iOhNl.lottie"
                                    loop
                                    autoplay
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
};

export default About;
